import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminCityDto, CityCreateInput, CityUpdateInput } from '@upme/contracts';
import { api } from '../../app/api-client';
import { citiesKey, cityByIdOptions } from './queries';

export function useCreateCity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CityCreateInput) => api.post('admin/cities', { json: body }).json<AdminCityDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...citiesKey] }),
  });
}

export function useUpdateCity(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CityUpdateInput) =>
      api.patch(`admin/cities/${id}`, { json: body }).json<AdminCityDto>(),
    onSuccess: (data) => {
      qc.setQueryData(cityByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: [...citiesKey] });
    },
  });
}

export function useDeleteCity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, hard }: { id: string; hard?: boolean }) =>
      api.delete(`admin/cities/${id}${hard ? '?hard=true' : ''}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...citiesKey] }),
  });
}
